$(function () {
    $(".description_content:first").css("display", "block"),
        $(".description_heading").click(function () {
            (divTrigger = $(".description_heading").index(this)),
                (thisMenu = $(".description_content:eq(" + divTrigger + ")")),
                $(".description_content").hide(),
                thisMenu.is(":not(':visible')") && thisMenu.show(),
                $(this).hasClass("heading_line") ? $(this).removeClass("heading_line") : ($(".description_heading").removeClass("heading_line"), $(this).removeClass("heading_block").addClass("heading_line"));
        });
}),
    $(".accordion-panel").on("click", ".accordion__header", function () {
        $(this).next().is(":hidden") ? ($(this).next().slideDown().addClass("flipInX"), $(this).find(".fa-solid").css("transform", "rotate(180deg)")) : ($(this).next().slideUp(), $(this).find(".fa-solid").css("transform", "rotate(0deg)"));
    }),
    $(window).on("scroll", function () {
        var contentTop = $(".product-info__buy-buttons").offset().top;
       var contentnewTop = parseInt(contentTop) + 200 ;  
        $(this).scrollTop() > contentnewTop ? $(".product_quick_add").addClass("is-visible") : $(".product_quick_add").removeClass("is-visible");
    }),
    $(window).on("scroll", function () {
        var contentTopyy = $(".product-info").offset().top;
     var contentnewTopyy = parseInt(contentTopyy) - 450 ; 
        $(this).scrollTop() < contentnewTopyy ? $(".product_quick_add").addClass("is--jtpl-visible") : $(".product_quick_add").removeClass("is--jtpl-visible");
    });
//# sourceMappingURL=/s/files/1/0671/5290/4457/t/21/assets/product-script.js.map?v=1682652096
$(document).ready(function () {
    $(".product_quick_add").addClass("is--jtpl-visible");
});
